import React from 'react';
import SessionTimeout from './SessionTimeout';

/* This HOC takes one argument: the component to be wrapped.
  It returns a new component that renders the Logout component and passes the Component as a child. */
function withLogout(MyComponent: React.FC<any>) {
  return (props: any) => (
    <SessionTimeout timeoutInMinutes={15} warningInMinutes={7}>
      <MyComponent {...props} />
    </SessionTimeout>
  );
}

export default withLogout;
